import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { sliderData } from "../../constants/HomePageData";
import SingleHeroSlider from "../SingleHeroSlider/SingleHeroSlider";

//slider configuration
const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};


const HeroSlider = () => {
    return (
        <div className="heroSlider">
            <Slider {...settings}>
                {sliderData && sliderData.map((singleSlide,index) => (
                    <SingleHeroSlider
                        title={singleSlide.title} 
                        sub={singleSlide.sub}
                        text={singleSlide.text}
                        link={singleSlide.link}
                        image={singleSlide.image}
                        buttonText={singleSlide.buttonText}
                        key={singleSlide.sub + index}
                    />
                ))}
            </Slider>
        </div>
    );
};

export default HeroSlider;